// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* btn-respond — base: neutral outline */
.btn-respond {
  background: #f8fafc !important;
  color: #334155 !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 16px !important;
  height: 40px !important;
  line-height: 1 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease !important;
  margin: 0;
}
.btn-respond:hover {
  background: #eef2f7 !important;
  border-color: #b6c4d4 !important;
}

/* Accept — soft green, matches ConsentForm__actions */
.btn-respond.btn-accept {
  background: #227ebd !important;
  color: #fff !important;
  border-color: transparent !important;
}
.btn-respond.btn-accept:hover {
  background: #1a6da3 !important;
}
.btn-respond.btn-accept:active {
  background: #155d8c !important;
}

/* Decline — muted outline, not alarming */
.btn-respond.btn-decline {
  background: #f8fafc !important;
  color: #64748b !important;
  border-color: #cbd5e1 !important;
}
.btn-respond.btn-decline:hover {
  background: #eef2f7 !important;
  color: #475569 !important;
  border-color: #b6c4d4 !important;
}

/* Close / cancel */
.btn-respond.btn-close {
  background: #f8fafc !important;
  color: #334155 !important;
  border-color: #cbd5e1 !important;
}
.btn-respond.btn-close:hover {
  background: #eef2f7 !important;
  border-color: #b6c4d4 !important;
}

/* outline-secondary variant */
.btn-respond.btn-outline-secondary {
  background: #f8fafc !important;
  color: #475569 !important;
  border-color: #cbd5e1 !important;
}
.btn-respond.btn-outline-secondary:hover {
  background: #eef2f7 !important;
  border-color: #b6c4d4 !important;
}

.sit-btn {
  --_h: var(--control-h-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: var(--_h);
  padding: 0 16px;
  font-family: var(--font-body);
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
  line-height: 1;
  white-space: nowrap;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;
  transition: background var(--dur-base) var(--ease-out), border-color var(--dur-base) var(--ease-out),
    color var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out),
    transform var(--dur-fast) var(--ease-out);
}

.sit-btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.sit-btn:active {
  transform: translateY(0.5px);
}

.sit-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.sit-btn--sm {
  --_h: var(--control-h-sm);
  padding: 0 12px;
  font-size: var(--text-sm);
}

.sit-btn--lg {
  --_h: var(--control-h-lg);
  padding: 0 22px;
  font-size: var(--text-lg);
}

.sit-btn--block {
  width: 100%;
}

.sit-btn--primary {
  background: var(--action-primary);
  color: var(--text-on-brand);
}

.sit-btn--primary:hover {
  background: var(--action-primary-hover);
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);
  color: var(--text-on-brand);
}

.sit-btn--primary:active {
  background: var(--action-primary-active);
  box-shadow: none;
}

.sit-btn--secondary {
  background: var(--slate-0);
  color: var(--text-body);
  border-color: var(--border-default);
}

.sit-btn--secondary:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
  color: var(--text-body);
}

.sit-btn--secondary:active {
  background: var(--surface-active);
}

.sit-btn--ghost {
  background: transparent;
  color: var(--text-body);
}

.sit-btn--ghost:hover {
  background: var(--surface-hover);
  color: var(--text-body);
}

.sit-btn--danger {
  background: var(--red-500);
  color: #fff;
}

.sit-btn--danger:hover {
  background: var(--red-600);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
  color: #fff;
}
.sitButtonCreateIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,qEAAqE;EACrE,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,sDAAsD;AACtD;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB;;6CAE2C;AAC7C;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;EAC9C,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* btn-respond — base: neutral outline */\n.btn-respond {\n  background: #f8fafc !important;\n  color: #334155 !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 8px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0 16px !important;\n  height: 40px !important;\n  line-height: 1 !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease !important;\n  margin: 0;\n}\n.btn-respond:hover {\n  background: #eef2f7 !important;\n  border-color: #b6c4d4 !important;\n}\n\n/* Accept — soft green, matches ConsentForm__actions */\n.btn-respond.btn-accept {\n  background: #227ebd !important;\n  color: #fff !important;\n  border-color: transparent !important;\n}\n.btn-respond.btn-accept:hover {\n  background: #1a6da3 !important;\n}\n.btn-respond.btn-accept:active {\n  background: #155d8c !important;\n}\n\n/* Decline — muted outline, not alarming */\n.btn-respond.btn-decline {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  border-color: #cbd5e1 !important;\n}\n.btn-respond.btn-decline:hover {\n  background: #eef2f7 !important;\n  color: #475569 !important;\n  border-color: #b6c4d4 !important;\n}\n\n/* Close / cancel */\n.btn-respond.btn-close {\n  background: #f8fafc !important;\n  color: #334155 !important;\n  border-color: #cbd5e1 !important;\n}\n.btn-respond.btn-close:hover {\n  background: #eef2f7 !important;\n  border-color: #b6c4d4 !important;\n}\n\n/* outline-secondary variant */\n.btn-respond.btn-outline-secondary {\n  background: #f8fafc !important;\n  color: #475569 !important;\n  border-color: #cbd5e1 !important;\n}\n.btn-respond.btn-outline-secondary:hover {\n  background: #eef2f7 !important;\n  border-color: #b6c4d4 !important;\n}\n\n.sit-btn {\n  --_h: var(--control-h-md);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: var(--_h);\n  padding: 0 16px;\n  font-family: var(--font-body);\n  font-size: var(--text-md);\n  font-weight: var(--weight-semibold);\n  line-height: 1;\n  white-space: nowrap;\n  border-radius: var(--radius-md);\n  border: 1px solid transparent;\n  cursor: pointer;\n  user-select: none;\n  transition: background var(--dur-base) var(--ease-out), border-color var(--dur-base) var(--ease-out),\n    color var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out),\n    transform var(--dur-fast) var(--ease-out);\n}\n\n.sit-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.sit-btn:active {\n  transform: translateY(0.5px);\n}\n\n.sit-btn[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.sit-btn--sm {\n  --_h: var(--control-h-sm);\n  padding: 0 12px;\n  font-size: var(--text-sm);\n}\n\n.sit-btn--lg {\n  --_h: var(--control-h-lg);\n  padding: 0 22px;\n  font-size: var(--text-lg);\n}\n\n.sit-btn--block {\n  width: 100%;\n}\n\n.sit-btn--primary {\n  background: var(--action-primary);\n  color: var(--text-on-brand);\n}\n\n.sit-btn--primary:hover {\n  background: var(--action-primary-hover);\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);\n  color: var(--text-on-brand);\n}\n\n.sit-btn--primary:active {\n  background: var(--action-primary-active);\n  box-shadow: none;\n}\n\n.sit-btn--secondary {\n  background: var(--slate-0);\n  color: var(--text-body);\n  border-color: var(--border-default);\n}\n\n.sit-btn--secondary:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n  color: var(--text-body);\n}\n\n.sit-btn--secondary:active {\n  background: var(--surface-active);\n}\n\n.sit-btn--ghost {\n  background: transparent;\n  color: var(--text-body);\n}\n\n.sit-btn--ghost:hover {\n  background: var(--surface-hover);\n  color: var(--text-body);\n}\n\n.sit-btn--danger {\n  background: var(--red-500);\n  color: #fff;\n}\n\n.sit-btn--danger:hover {\n  background: var(--red-600);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n  color: #fff;\n}\n.sitButtonCreateIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 7px;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
